import type { PaginatedPassengerAddressList } from '@bambi/api-client/schemas';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';
import { ClockIcon } from '@heroicons/react/24/outline';

interface getLocationOptionAdornmentProps {
  option: SelectOption;
  recentAddressResponse: PaginatedPassengerAddressList | undefined;
}

export default function getLocationOptionAdornment({
  option,
  recentAddressResponse,
}: getLocationOptionAdornmentProps) {
  const recentAddress = recentAddressResponse?.results.find(
    (result) => result.address.location?.place_id === option.value
  );

  if (recentAddress) {
    return (
      <span>
        <ClockIcon data-testid="clock-icon" className="h-4 w-4" />{' '}
      </span>
    );
  }

  return undefined;
}
